import { useCallback, useState } from 'react';
import { ScheduleDesviationRule } from 'repository/timekeeper/@types/ScheduleDesviationRuleModel';
import { TimekeeperService } from 'services/TimekeeperService';

const timekeeperService = new TimekeeperService();

export const useScheduleDesviationQuery = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<ScheduleDesviationRule[]>([]);

    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const data = await timekeeperService.schedule_desviation.getScheduleDesviations();
            const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
            setRows(sortedData as ScheduleDesviationRule[]);
        } catch (error) {
            console.error('Error loading schedule deviations:', error);
            setLoading(false);
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        rows,
        loading,
        setRows,
        loadData,
        setLoading,
    };
};
